(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-editorial-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-editorial-carousel')) {
    customElements.define('maison-editorial-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
        if (!this.track || !this.slides.length) return;
        this.index = 0;
        this.pages = [...this.querySelectorAll('[data-carousel-page]')];
        this.previous = this.querySelector('[data-carousel-previous]');
        this.next = this.querySelector('[data-carousel-next]');
        this.position = this.querySelector('[data-carousel-position]');
        const controls = this.querySelector('[data-carousel-controls]');
        if (controls) controls.hidden = this.slides.length < 2;
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button === this.previous) this.go(this.index - 1);
          else if (button === this.next) this.go(this.index + 1);
          else if (button.hasAttribute('data-carousel-page')) this.go(Number(button.dataset.carouselPage));
        }, { signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          const nextKey = rtl ? 'ArrowLeft' : 'ArrowRight';
          const previousKey = rtl ? 'ArrowRight' : 'ArrowLeft';
          let destination;
          if (event.key === nextKey) destination = this.index + 1;
          else if (event.key === previousKey) destination = this.index - 1;
          else if (event.key === 'Home') destination = 0;
          else if (event.key === 'End') destination = this.slides.length - 1;
          else return;
          event.preventDefault();
          this.go(destination);
        }, { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.readPosition());
        }, { signal, passive: true });
        this.track.addEventListener('focusin', event => {
          const slide = event.target.closest('[data-carousel-slide]');
          if (slide) this.go(this.slides.indexOf(slide), true);
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === String(event.detail?.blockId));
          if (selected >= 0 && (!event.detail?.sectionId || String(event.detail.sectionId) === this.dataset.sectionId)) this.go(selected, true);
        }, { signal });
        this.observer = new ResizeObserver(() => this.go(this.index, true));
        this.observer.observe(this.track);
        this.update(0);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      offset(slide) {
        const track = this.track.getBoundingClientRect();
        const item = slide.getBoundingClientRect();
        const style = getComputedStyle(this.track);
        const inset = parseFloat(style.scrollPaddingInlineStart) || 0;
        return style.direction === 'rtl' ? item.right - track.right + inset : item.left - track.left - inset;
      }
      go(index, immediate = false) {
        const destination = Math.max(0, Math.min(index, this.slides.length - 1));
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: this.offset(this.slides[destination]), behavior: immediate || reducedMotion ? 'instant' : 'smooth' });
        if (immediate) this.update(destination);
      }
      readPosition() {
        let nearest = 0;
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          const offset = Math.abs(this.offset(slide));
          if (offset < distance) { nearest = index; distance = offset; }
        });
        this.update(nearest);
      }
      update(index) {
        this.index = index;
        if (this.previous) this.previous.disabled = index === 0;
        if (this.next) this.next.disabled = index === this.slides.length - 1;
        this.pages.forEach((button, number) => {
          if (number === index) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        if (this.position) {
          const label = this.dataset.positionTemplate.replace('__current__', String(index + 1));
          if (this.position.textContent !== label) this.position.textContent = label;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-hero"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('maison-hero-slideshow')) {
    customElements.define('maison-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.allSlides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.slides = this.allSlides.filter(slide => !slide.hasAttribute('data-empty'));
        this.active = this.querySelector('[data-active]') || this.allSlides[0];
        this.controls = this.querySelector('[data-hero-controls]');
        this.pauseButton = this.querySelector('[data-hero-pause]');
        this.status = this.querySelector('[data-hero-status]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.interval = Math.max(3000, Number(this.dataset.interval) || 6000);
        this.fade = Math.max(0, Number.isFinite(Number(this.dataset.fade)) ? Number(this.dataset.fade) : 1000);
        this.userPaused = false;
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.inView = true;
        this.busy = false;
        this.requestId = (this.requestId || 0) + 1;
        const multiple = this.slides.length > 1;
        this.controls.hidden = !multiple || this.dataset.arrows !== 'true';
        this.pauseButton.hidden = !multiple || this.dataset.autoplay !== 'true';
        this.listen(this.querySelector('[data-hero-previous]'), 'click', () => this.step(-1, true));
        this.listen(this.querySelector('[data-hero-next]'), 'click', () => this.step(1, true));
        this.listen(this.pauseButton, 'click', () => {
          this.userPaused = !this.userPaused;
          this.updatePauseButton();
          this.schedule();
        });
        this.listen(this, 'pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
        });
        this.listen(this, 'pointerleave', event => {
          if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); }
        });
        this.listen(this, 'focusin', event => { this.focused = event.target.matches(':focus-visible'); this.schedule(); });
        this.listen(this, 'focusout', event => {
          this.focused = this.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible');
          this.schedule();
        });
        this.listen(this, 'keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.target.closest('input, textarea, select, [contenteditable]')) return;
          event.preventDefault();
          this.step(event.key === 'ArrowLeft' ? -1 : 1, true);
        });
        this.listen(this, 'pointerdown', event => {
          if (event.pointerType === 'mouse') return;
          this.revealControls();
          if (!event.target.closest('button, a')) this.gesture = { x: event.clientX, y: event.clientY, id: event.pointerId };
        });
        this.listen(this, 'pointerup', event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || start.id !== event.pointerId) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (Math.abs(dx) > 50 && Math.abs(dy) < Math.abs(dx) * 0.65) this.step(dx < 0 ? 1 : -1, true);
        });
        this.listen(this, 'pointercancel', () => { this.gesture = null; });
        this.listen(document, 'visibilitychange', () => this.schedule());
        this.listen(this.motion, 'change', () => { this.updatePauseButton(); this.schedule(); });
        this.listen(this, 'shopify:block:select', event => {
          const slide = this.allSlides.find(item => item.dataset.blockId === event.detail.blockId);
          this.editorSelected = true;
          if (slide) this.show(slide, false, true);
          this.schedule();
        });
        this.listen(this, 'shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); });
        const section = this.closest('.shopify-section');
        if (section) {
          this.listen(section, 'shopify:section:select', () => { this.editorSelected = true; this.schedule(); });
          this.listen(section, 'shopify:section:deselect', () => { this.editorSelected = false; this.schedule(); });
        }
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.schedule();
          });
          this.observer.observe(this);
        }
        this.updatePauseButton();
        this.schedule();
      }
      listen(target, type, callback) {
        target?.addEventListener(type, callback, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.fadeTimer);
        clearTimeout(this.controlsTimer);
        this.requestId++;
        this.finishTransition();
      }
      updatePauseButton() {
        const paused = this.userPaused || this.motion.matches;
        this.pauseButton.setAttribute('aria-pressed', String(paused));
        this.pauseButton.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.pauseButton.hidden = this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.motion.matches;
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.userPaused || this.hovered || this.focused || this.editorSelected || !this.inView || document.hidden || this.motion.matches) return;
        this.timer = setTimeout(() => this.step(1), Math.max(this.interval, this.fade + 500));
      }
      revealControls() {
        this.setAttribute('data-controls-visible', '');
        clearTimeout(this.controlsTimer);
        this.controlsTimer = setTimeout(() => this.removeAttribute('data-controls-visible'), 3500);
      }
      step(direction, manual = false) {
        if (this.slides.length < 2 || this.busy) return;
        const current = this.slides.indexOf(this.active);
        const index = (current + direction + this.slides.length) % this.slides.length;
        this.show(this.slides[index], manual);
      }
      finishTransition() {
        clearTimeout(this.fadeTimer);
        this.allSlides?.forEach(slide => slide.removeAttribute('data-outgoing'));
        this.busy = false;
        this.removeAttribute('data-instant');
      }
      async show(next, manual = false, instant = false) {
        if (!next || next === this.active) return;
        clearTimeout(this.timer);
        const requestId = ++this.requestId;
        this.finishTransition();
        this.busy = true;
        const photo = next.querySelector('img');
        if (photo) {
          photo.loading = 'eager';
          try { await photo.decode(); } catch {}
          if (requestId !== this.requestId || !this.isConnected) return;
          if (!photo.naturalWidth) { this.busy = false; this.schedule(); return; }
        }
        if (instant || this.motion.matches) this.setAttribute('data-instant', '');
        this.active?.removeAttribute('data-active');
        this.active?.setAttribute('aria-hidden', 'true');
        this.active?.setAttribute('data-outgoing', '');
        next.getBoundingClientRect();
        next.setAttribute('aria-hidden', 'false');
        next.setAttribute('data-active', '');
        this.active = next;
        if (manual) this.status.textContent = this.dataset.positionTemplate.replace('__current__', String(this.slides.indexOf(next) + 1));
        const duration = instant || this.motion.matches ? 0 : this.fade;
        this.fadeTimer = setTimeout(() => this.finishTransition(), duration + 30);
        this.schedule();
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-selection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maison-selection')) {
  customElements.define('maison-selection', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.track = this.querySelector('[data-track]');
      if (!this.track) { this.controller = null; return; }
      this.viewport = this.querySelector('[data-viewport]');
      this.cards = Array.from(this.track.querySelectorAll('[data-card]'));
      this.navigation = this.querySelector('[data-navigation]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.counter = this.querySelector('[data-counter]');
      this.footer = this.querySelector('[data-footer]');
      this.progress = this.querySelector('[data-progress]');
      this.status = this.querySelector('[data-status]');
      this.pendingIndex = null;
      const signal = this.controller.signal;
      this.previous.addEventListener('click', () => this.step(-1), { signal });
      this.next.addEventListener('click', () => this.step(1), { signal });
      this.track.addEventListener('pointerdown', () => { this.pendingIndex = null; }, { passive: true, signal });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
        clearTimeout(this.announcement);
        this.announcement = setTimeout(() => {
          this.pendingIndex = null;
          this.update(true);
        }, 160);
      }, { passive: true, signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.step((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : this.cards.length - 1);
        }
      }, { signal });
      this.track.addEventListener('focusin', event => {
        const card = event.target.closest('[data-card]');
        if (!card) return;
        const bounds = this.track.getBoundingClientRect();
        const rect = card.getBoundingClientRect();
        if (rect.left < bounds.left - 2 || rect.right > bounds.right + 2) this.go(this.cards.indexOf(card), true);
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.go(index, true);
      }, { signal });
      this.track.addEventListener('load', () => this.update(), { capture: true, signal });
      this.observer = new ResizeObserver(() => {
        this.pendingIndex = null;
        this.update();
      });
      this.observer.observe(this.track);
      this.cards.forEach(card => {
        this.observer.observe(card);
        const media = card.querySelector('.mx-card__media');
        if (media) this.observer.observe(media);
      });
      this.setAttribute('data-ready', '');
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.announcement);
      this.removeAttribute('data-ready');
    }
    update(announce = false) {
      if (!this.cards.length) {
        this.navigation.hidden = true;
        if (this.footer) this.footer.hidden = true;
        return;
      }
      const bounds = this.track.getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const rects = this.cards.map(card => card.getBoundingClientRect());
      const first = rects[0];
      const last = rects[rects.length - 1];
      const overflowing = this.track.scrollWidth > this.track.clientWidth + 2;
      const atStart = rtl ? first.right <= bounds.right + 2 : first.left >= bounds.left - 2;
      const atEnd = rtl ? last.left >= bounds.left - 2 : last.right <= bounds.right + 2;
      const active = this.ownerDocument.activeElement;
      const transferFocus = active === this.previous && atStart || active === this.next && atEnd;
      this.navigation.hidden = !overflowing;
      this.previous.hidden = this.previous.disabled = !overflowing || atStart;
      this.next.hidden = this.next.disabled = !overflowing || atEnd;
      if (this.footer) this.footer.hidden = !overflowing;
      const media = this.cards[0].querySelector('.mx-card__media')?.getBoundingClientRect();
      if (media?.height) {
        const container = this.viewport.getBoundingClientRect();
        const fraction = Math.max(0.1, Math.min(0.9, Number(this.dataset.arrowPosition || 50) / 100));
        this.viewport.style.setProperty('--nav-y', `${media.top - container.top + media.height * fraction}px`);
      }
      this.index = rects.reduce((nearest, rect, index) => {
        const distance = Math.abs(rtl ? bounds.right - rect.right : rect.left - bounds.left);
        return distance < nearest.distance ? { index, distance } : nearest;
      }, { index: 0, distance: Infinity }).index;
      if (atEnd && this.pendingIndex !== null && this.pendingIndex > this.index) this.pendingIndex = this.index;
      const visible = rects.map((rect, index) => ({ index, fraction: Math.max(0, Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left)) / Math.max(1, rect.width) })).filter(item => item.fraction > 0.6);
      const start = (visible[0]?.index ?? this.index) + 1;
      const end = (visible[visible.length - 1]?.index ?? this.index) + 1;
      if (this.counter) this.counter.textContent = `${start === end ? String(start).padStart(2, '0') : `${String(start).padStart(2, '0')}–${String(end).padStart(2, '0')}`} / ${String(this.cards.length).padStart(2, '0')}`;
      if (this.progress) this.progress.style.setProperty('--progress', String(atEnd ? 1 : Math.min(1, end / this.cards.length)));
      if (announce) this.status.textContent = this.dataset.rangeTemplate.replace('__start__', String(start)).replace('__end__', String(end));
      if (transferFocus) {
        const target = !this.previous.hidden ? this.previous : !this.next.hidden ? this.next : this.track;
        target.focus({ preventScroll: true });
      }
    }
    step(direction) {
      this.update();
      if (direction < 0 && this.previous.disabled || direction > 0 && this.next.disabled) return;
      const base = this.pendingIndex ?? this.index;
      this.go(Math.max(0, Math.min(this.cards.length - 1, base + direction)));
    }
    go(index, instant = false) {
      const card = this.cards[index];
      if (!card) return;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const bounds = this.track.getBoundingClientRect();
      const rect = card.getBoundingClientRect();
      this.pendingIndex = index;
      const immediate = instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: rtl ? rect.right - bounds.right : rect.left - bounds.left, behavior: immediate ? 'instant' : 'smooth' });
      if (immediate) this.pendingIndex = null;
      this.update();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiffany-arrivals"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tiffany-arrivals')) {
  customElements.define('tiffany-arrivals', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.panel = this.querySelector('[data-panel]');
      this.track = this.querySelector('[data-track]');
      this.status = this.querySelector('[data-status]');
      this.loaded = false;
      this.loading = false;
      this.panel.querySelector('[data-previous]').addEventListener('click', () => this.step(this.panel, -1), { signal });
      this.panel.querySelector('[data-next]').addEventListener('click', () => this.step(this.panel, 1), { signal });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.panel.frame);
        this.panel.frame = requestAnimationFrame(() => this.update(this.panel));
      }, { passive: true, signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.step(this.panel, (event.key === 'ArrowRight' ? 1 : -1) * (getComputedStyle(this.track).direction === 'rtl' ? -1 : 1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.go(this.panel, event.key === 'Home' ? 0 : this.track.children.length - 1);
        }
      }, { signal });
      this.track.addEventListener('focusin', event => {
        const card = event.target.closest('[data-card]');
        if (!card) return;
        const a = card.getBoundingClientRect(), b = this.track.getBoundingClientRect();
        if (a.left < b.left - 2 || a.right > b.right + 2) this.go(this.panel, [...this.track.children].indexOf(card), true);
      }, { signal });
      this.track.addEventListener('load', () => this.update(this.panel), { capture: true, signal });
      this.observer = new ResizeObserver(() => this.update(this.panel));
      this.observer.observe(this);
      this.setAttribute('data-ready', '');
      this.update(this.panel);
      this.intersection = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { this.load(); this.intersection.disconnect(); }
      }, { rootMargin: '400px' });
      this.intersection.observe(this);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.intersection?.disconnect();
      cancelAnimationFrame(this.panel?.frame);
    }
    shuffle(items) {
      const result = [...items];
      for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
      }
      return result;
    }
    unique(cards) {
      const seen = new Set();
      return cards.filter(card => {
        const id = card.dataset.productId;
        if (!id || seen.has(id)) return false;
        seen.add(id); return true;
      });
    }
    selectCards(groups) {
      const selected = new Map();
      for (const group of this.shuffle(groups.filter(group => group.required))) {
        const candidates = group.cards.slice(0, 5);
        const chosen = this.shuffle(candidates.filter(card => !selected.has(card.dataset.productId)))[0];
        if (chosen) selected.set(chosen.dataset.productId, chosen);
      }
      for (const card of this.shuffle(this.unique(groups.flatMap(group => group.cards)))) {
        if (selected.size >= 8) break;
        selected.set(card.dataset.productId, card);
      }
      return this.shuffle([...selected.values()]).slice(0, 8);
    }
    async readSource(source, signal) {
      const url = new URL(source.dataset.url, location.href);
      url.search = '';
      url.searchParams.set('sort_by', 'created-desc');
      url.searchParams.set('section_id', 'tiffany-arrivals-feed');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error('Gallery response failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const template = doc.querySelector('template[data-arrivals-feed]');
      if (!template || template.dataset.collectionHandle !== source.dataset.handle) throw new Error('Gallery collection mismatch');
      return this.unique([...template.content.querySelectorAll('[data-card]')]);
    }
    async load() {
      if (this.loaded || this.loading) return;
      const lifecycle = this.controller;
      const timeout = new AbortController();
      const timer = setTimeout(() => timeout.abort(), 12000);
      const abort = () => timeout.abort();
      lifecycle.signal.addEventListener('abort', abort, { once: true });
      const sources = [...this.querySelectorAll('[data-arrivals-source]')].filter((source, index, all) => all.findIndex(other => other.dataset.handle === source.dataset.handle) === index);
      this.loading = true;
      this.panel.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loadingText;
      try {
        const responses = await Promise.allSettled(sources.map(source => this.readSource(source, timeout.signal)));
        if (lifecycle.signal.aborted) return;
        const groups = sources.map((source, i) => ({
          required: source.dataset.required === 'true',
          cards: responses[i].status === 'fulfilled' ? responses[i].value : this.unique([...source.content.querySelectorAll('[data-card]')].map(card => card.cloneNode(true)))
        }));
        const cards = this.selectCards(groups);
        if (this.track.contains(document.activeElement)) this.track.focus({ preventScroll: true });
        const browse = this.track.querySelector('[data-browse-card]');
        this.track.replaceChildren(...cards, ...(browse ? [browse] : []));
        this.track.scrollLeft = 0;
        this.loaded = true;
        this.update(this.panel);
        this.status.textContent = this.dataset.readyText.replace('__count__', String(cards.length));
      } catch (error) {
        if (!lifecycle.signal.aborted) this.status.textContent = this.dataset.fallbackText;
      } finally {
        clearTimeout(timer);
        lifecycle.signal.removeEventListener('abort', abort);
        if (!lifecycle.signal.aborted) { this.loading = false; this.panel.removeAttribute('aria-busy'); }
      }
    }
    update(panel) {
      if (panel.hidden) return;
      const track = panel.querySelector('[data-track]'), cards = [...track.querySelectorAll('[data-card]')];
      panel.querySelector('[data-empty]').hidden = cards.length > 0;
      panel.querySelector('[data-viewport]').hidden = cards.length === 0;
      panel.toggleAttribute('data-single', cards.length === 1);
      const previous = panel.querySelector('[data-previous]'), next = panel.querySelector('[data-next]');
      const bounds = track.getBoundingClientRect(), first = cards[0]?.getBoundingClientRect(), last = cards.at(-1)?.getBoundingClientRect();
      const rtl = getComputedStyle(track).direction === 'rtl';
      const overflowing = cards.length > 0 && track.scrollWidth > track.clientWidth + 2;
      const atStart = !first || (rtl ? first.right <= bounds.right + 2 : first.left >= bounds.left - 2);
      const atEnd = !last || (rtl ? last.left >= bounds.left - 2 : last.right <= bounds.right + 2);
      panel.querySelector('[data-navigation]').hidden = !overflowing;
      previous.hidden = previous.disabled = !overflowing || atStart;
      next.hidden = next.disabled = !overflowing || atEnd;
      const media = cards[0]?.querySelector('.ta-card__photo').getBoundingClientRect();
      if (media?.height) panel.style.setProperty('--ta-nav-y', `${media.top - panel.getBoundingClientRect().top + media.height / 2}px`);
      const focused = document.activeElement;
      if ((focused === previous && previous.hidden) || (focused === next && next.hidden)) (!previous.hidden ? previous : !next.hidden ? next : track).focus({ preventScroll: true });
    }
    step(panel, direction) {
      const track = panel.querySelector('[data-track]'), cards = [...track.children];
      const bounds = track.getBoundingClientRect(), style = getComputedStyle(track), rtl = style.direction === 'rtl';
      const scale = bounds.width / track.offsetWidth || 1, gap = parseFloat(style.columnGap) || 0;
      const width = cards[0]?.getBoundingClientRect().width / scale;
      const pageSize = Math.max(1, Math.floor((track.clientWidth + gap + 2) / (width + gap)));
      const distances = cards.map(card => { const rect = card.getBoundingClientRect(); return Math.abs(rtl ? rect.right - bounds.right : rect.left - bounds.left); });
      const index = distances.indexOf(Math.min(...distances));
      this.go(panel, Math.max(0, Math.min(cards.length - 1, index + direction * pageSize)));
    }
    go(panel, index, instant = false) {
      const track = panel.querySelector('[data-track]'), card = track.children[index];
      if (!card) return;
      const bounds = track.getBoundingClientRect(), rect = card.getBoundingClientRect(), rtl = getComputedStyle(track).direction === 'rtl';
      const scale = bounds.width / track.offsetWidth || 1;
      const padding = parseFloat(getComputedStyle(track).paddingInlineStart) || 0;
      const delta = (rtl ? rect.right - bounds.right : rect.left - bounds.left) / scale + (rtl ? padding : -padding);
      track.scrollBy({ left: delta, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiffany-collection-types"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tiffany-type-browser')) {
    customElements.define('tiffany-type-browser', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.tm-types__toggle');
        this.panel = this.querySelector('.tm-types__panel');
        if (!this.button || !this.panel) return;
        this.media = matchMedia('(max-width: 749px)');
        this.togglePanel = () => this.setOpen(!this.hasAttribute('data-open'));
        this.handleKey = event => {
          if (event.key === 'Escape' && this.media.matches && this.hasAttribute('data-open')) {
            event.preventDefault();
            this.setOpen(false);
            this.button.focus();
          }
        };
        this.handleNavigation = event => {
          if (!this.media.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (event.target.closest('a[href]')) this.setOpen(false);
        };
        this.handleViewport = () => this.setOpen(false);
        this.button.addEventListener('click', this.togglePanel);
        this.addEventListener('keydown', this.handleKey);
        this.panel.addEventListener('click', this.handleNavigation);
        this.media.addEventListener('change', this.handleViewport);
        this.setOpen(false);
      }
      setOpen(open) {
        this.toggleAttribute('data-open', open);
        this.button.setAttribute('aria-expanded', String(open));
      }
      disconnectedCallback() {
        this.button?.removeEventListener('click', this.togglePanel);
        this.removeEventListener('keydown', this.handleKey);
        this.panel?.removeEventListener('click', this.handleNavigation);
        this.media?.removeEventListener('change', this.handleViewport);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiffany-topbar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  for (const disclosure of document.querySelectorAll('.tm-topbar__disclosure[open]')) {
    if (!event.composedPath().includes(disclosure)) disclosure.open = false;
  }
}, { capture: true });

document.addEventListener('focusin', event => {
  for (const disclosure of document.querySelectorAll('.tm-topbar__disclosure[open]')) {
    if (!disclosure.contains(event.target)) disclosure.open = false;
  }
});

document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  for (const disclosure of document.querySelectorAll('.tm-topbar__disclosure[open]')) {
    const restoreFocus = disclosure.contains(document.activeElement);
    disclosure.open = false;
    if (restoreFocus) disclosure.querySelector('summary')?.focus();
  }
});

  } catch(e) { console.error(e); }
})();
})();
